import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import Modal from '../common/Modal';
import Input from '../common/Input';
import Button from '../common/Button';

const EditSimpleModal = ({ simple, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: simple.name,
    email: simple.email,
    ownerId: simple.ownerId?._id || '',
    active: simple.active,
  });
  const [owners, setOwners] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchOwners();
  }, []);

  const fetchOwners = async () => {
    try {
      const response = await api.get('/owners');
      setOwners(response.data.data);
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.put(`/admins/simples/${simple._id}`, formData);
      alert('User Simple modifié avec succès');
      onSuccess();
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur lors de la modification');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal title="✏️ Modifier le User Simple" onClose={onClose}>
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          label="Nom complet"
          required
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />

        <Input
          label="Email"
          type="email"
          required
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        />

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Owner
          </label>
          <select
            required
            value={formData.ownerId}
            onChange={(e) => setFormData({ ...formData, ownerId: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          >
            <option value="">-- Sélectionner un Owner --</option>
            {owners.map((owner) => (
              <option key={owner._id} value={owner._id}>
                {owner.name} ({owner.email})
              </option>
            ))}
          </select>
        </div>

        <div className="flex items-center space-x-3">
          <input
            type="checkbox"
            id="active"
            checked={formData.active}
            onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
            className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
          />
          <label htmlFor="active" className="text-sm font-medium text-gray-700">
            Compte actif
          </label>
        </div>

        <div className="flex space-x-3 pt-4">
          <Button type="submit" disabled={loading} className="flex-1">
            {loading ? 'Modification...' : 'Modifier'}
          </Button>
          <Button type="button" variant="secondary" onClick={onClose} className="flex-1">
            Annuler
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default EditSimpleModal;